import { Injectable } from '@angular/core';
import { HttpService } from '../../service/http.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RecalculateSummarySalesService {

  constructor(private httpService: HttpService) { }

  getActiveCounter(params: any): Observable<any> {
    return this.httpService.post('get-active-counter', params);
  }

  recalculateSummarySales(data: any): Observable<any> {
    return this.httpService.post('recalculate-summary-sales', data);
  }
}
